/**
* @file 营销活动-新增活动抽屉
*/
<template>
  <el-drawer :visible="isVisible" title="" size="1030px" :destroy-on-close="true" :with-header="true"
    :close-on-click-modal="false" @close="handleClose">
    <div class="activity-title">惊喜盲盒</div>
    <!-- 顶部提示 -->
    <div class="blueInfo" style="display: flex;align-items: center;gap: 8px; ">
      <i class="el-icon-warning" style="color: #409EFF;font-size: 18px;"></i>
      <span>用户参与活动拆盲盒后，系统随机派发活动奖池内的优惠券</span>
    </div>

    <div class="activity-container">
      <el-form ref="activityForm" :model="form" :rules="formRules" label-width="100px" class="activity-form">
        <!-- 基础信息 -->
        <div class="formTitle">基础信息</div>
        <el-form-item label="机构名称" prop="organizationId">
          <el-select v-model="form.organizationId" placeholder="请选择机构名称" clearable @change="organizationChange" filterable>
            <el-option v-for="item in organizations" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="活动标题" prop="name">
          <el-input v-model="form.name" maxlength="10" show-word-limit placeholder="请输入10字以内的名称" />
        </el-form-item>
        <el-form-item label="活动时间" prop="activityDate">
          <el-date-picker v-model="form.activityDate" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" style="width: 100%" value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item label="活动说明" prop="explanation">
          <el-input v-model="form.explanation" type="textarea" placeholder="请输入" :rows="4" :maxlength="200" />
        </el-form-item>

        <!-- 活动内容 -->
        <div class="formTitle">活动内容</div>
        <el-form-item label="达成条件" required>
          <span>参与活动拆盲盒</span>
        </el-form-item>
        <el-form-item label="活动奖励" prop="issuedNum">
          <el-input v-model="form.issuedNum" placeholder="请输入" v-input-filter="{ min: 1, max: 5, precision: 0 }">
            <template #prepend>随机掉落</template>
            <template #append>张优惠券</template>
          </el-input>
        </el-form-item>
        <el-form-item label="活动奖池" prop="couponPool" required>
          <div v-for="(item, index) in form.couponPool" :key="index" class="pool-item">
            <el-select v-model="item.couponId" placeholder="请选择" style="margin-right: 8px;"
              :disabled="!form.organizationId">
              <el-option v-for="option in couponTypes" :key="option.value" :label="option.label" :value="option.value"
                :disabled="form.couponPool.some((pool, idx) => pool.couponId === option.value && idx !== index)" />
            </el-select>
            <el-input v-model="item.totalNum" placeholder="请输入" style="width: 105px; margin-right: 8px; flex-shrink: 0;"
              :disabled="!form.organizationId" v-input-filter="{ min: 1, max: 999999, precision: 0 }">
              <template #append>张</template>
            </el-input>
            <el-button type="danger" @click="removePool(index)" :disabled="!form.organizationId">删除</el-button>
          </div>
          <el-button type="primary" plain @click="addPool" style="width: 100%;"
            :disabled="!form.organizationId || form.couponPool.length >= 5">添加1个优惠券（最多还可添加{{ 5 - form.couponPool.length
            }}个）</el-button>
        </el-form-item>
        <el-form-item label="参与次数" required>
          <span>活动时间内可参与1次</span>
        </el-form-item>

        <!-- 操作按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>

      <div class="activity-example">
        <example :activityInfo="activityInfo" />
      </div>
    </div>

  </el-drawer>
</template>

<script>
import example from './example.vue'
export default {
  name: 'ActivityAdd',
  components: {
    example
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        organizationId: '',
        name: '',
        activityDate: [],
        explanation: '',
        issuedNum: '',
        couponPool: [
          {
            couponId: '',
            totalNum: null,
          }
        ]
      },
      formRules: {
        organizationId: [{ required: true, message: '请选择机构名称', trigger: 'change' }],
        name: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        activityDate: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
        explanation: [{ required: true, message: '请输入活动说明', trigger: 'blur' }],
        issuedNum: [
          { required: true, message: '请输入随机掉落数量', trigger: 'blur' },
          { type: 'number', message: '必须为数字', transform: value => Number(value) }
        ],
        couponPool: [
          {
            validator(rule, value, callback) {
              if (!value || !value.length) {
                callback(new Error('请至少添加一个优惠券'));
                return;
              }
              for (let i = 0; i < value.length; i++) {
                if (!value[i].couponId) {
                  callback(new Error(`第${i + 1}个奖池项未选择优惠券`));
                  return;
                }
                if (!value[i].totalNum) {
                  callback(new Error(`第${i + 1}个奖池项未填写数量`));
                  return;
                }
              }
              callback();
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 禁用今天之前的日期
        }
      },
      // 优惠券类型选项
      couponTypes: [],
      submitLoading: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      }
    },
    activityInfo() {
      return {
        name: this.form.name,
        time: this.form.activityDate.map(item => this.$utils.timeFn(item, 'YYYY-MM-DD')).join(' - '),
        rule: '参与活动拆盲盒',
        description: this.form.explanation
      }
    }
  },

  created() {
    this.mixinOrganizations()
  },
  methods: {
    organizationChange(orgId) {
      this.getCouponList(orgId)
      this.form.couponPool = [
        {
          couponId: '',
          totalNum: null,
        }
      ]
    },
    async getCouponList(orgId) {
      const { data } = await this.$axios.get('/api/v1/manage/activity/available-coupons', {
        organizationId: orgId
      })
      this.couponTypes = data.map(item => ({
        label: item.name,
        value: item.id
      }))
    },
    /**
     * 添加奖池项
     */
    addPool() {
      if (this.form.couponPool.length < 5) {
        this.form.couponPool.push({
          couponId: '',
          totalNum: null,
        })
      }
    },

    /**
     * 删除奖池项
     * @param {number} index - 要删除的索引
     */
    removePool(index) {
      this.form.couponPool.splice(index, 1)
      
    },

    /**
     * 提交表单
     */
    submitForm() {
      this.$refs.activityForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true
          try {
            const formData = {
              ...this.form,
              startDate: Math.floor(new Date(this.form.activityDate[0]).setHours(0, 0, 0, 0) / 1000),
              endDate: Math.floor(new Date(this.form.activityDate[1]).setHours(23, 59, 59, 0) / 1000),
              couponPool: JSON.stringify(this.form.couponPool.map(item => ({
                couponId: item.couponId,
                couponName: this.couponTypes.find(option => option.value === item.couponId)?.label || '',
                totalNum: item.totalNum
              })))
            }
            const { code } = await this.$axios.post('/api/v1/manage/activity', formData)
            if (code === 1) {
              this.$message.success('创建成功')
              this.$emit('success')
              this.handleClose()
            }
          } finally {
            this.submitLoading = false
          }
        }
      })
    },

    /**
     * 关闭抽屉
     */
    handleClose() {
      this.$refs.activityForm.resetFields()
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.activity-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.activity-container {
  margin-top: 16px;
  display: flex;
  align-items: flex-start;
  gap: 20px;

  .pool-item{
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .activity-example {
    width: 375px;
    flex-shrink: 0;
  }
}

::v-deep .el-input-group__append {
  padding: 0 10px;
}
</style>